<template>
  <div>
    <div class="second_nav">
      <ul>
        <li
          @click="nav1(1)"
          @mouseover="onMouseOver1(1)"
          @mouseout="onMouseout1(1)"
        >
          <!-- <router-link :to="base"> -->

          <img src="../assets/image/patten.png" alt />

          <p class="white" :class="{ p_color: choose == 1 }">新闻资讯</p>
          <!-- </router-link> -->
        </li>
        <li
          @click="nav2(2)"
          @mouseover="onMouseOver1(2)"
          @mouseout="onMouseout1(2)"
        >
          <img src="../assets/image/patten.png" alt />

          <p class="white" :class="{ p_color: choose == 2 }">活动公告</p>
        </li>
        <li
          @click="nav3(3)"
          @mouseover="onMouseOver1(3)"
          @mouseout="onMouseout1(3)"
        >
          <img src="../assets/image/patten.png" alt />

          <p class="white" :class="{ p_color: choose == 3 }">馆务公开</p>
        </li>
        <li
          @click="nav4(4)"
          @mouseover="onMouseOver1(4)"
          @mouseout="onMouseout1(4)"
        >
          <!-- <router-link :to="base"> -->

          <img src="../assets/image/patten.png" alt />

          <p class="white" :class="{ p_color: choose == 4 }">文博动态</p>
        </li>
        <!-- <li @click="nav5(5)" @mouseover="onMouseOver1(5)" @mouseout="onMouseout1(4)">
          <img src="../assets/image/patten.png" alt />

          <p class="white" :class="{p_color:choose==5}">大事记</p>
        </li> -->
      </ul>
    </div>
    <div></div>
  </div>
</template>
<script>
export default {
  name: "show",
  data() {
    return {
      choose: "",
      seen: false,
    };
  },

  methods: {
    nav1(i) {
      (this.choose = i),
        (this.seen = false),
        this.$emit("childByvalue3", this.seen),
        this.$router
          .push({
            path: "/guanwugongkai/guanwugongkai2/:id",
            query: { orderId: "新闻资讯", zixun: "xinwenzixun" },
          })
          .catch((err) => {
            err;
          });
    },
    nav2(i) {
      (this.choose = i),
        (this.seen = false),
        this.$emit("childByvalue3", this.seen),
        this.$router
          .push({
            path: "/guanwugongkai/guanwugongkai2/:id",
            query: { orderId: "活动公告", zixun: "huodonggonggao" },
          })
          .catch((err) => {
            err;
          });
    },
    nav3(i) {
      (this.choose = i),
        (this.seen = false),
        this.$emit("childByvalue3", this.seen),
        this.$router
          .push({
            path: "/guanwugongkai/guanwugongkai2/:id",
            query: { orderId: "馆务公开", zixun: "guanwugongkai" },
          })
          .catch((err) => {
            err;
          });
    },
    nav4(i) {
      (this.choose = i),
        (this.seen = false),
        this.$emit("childByvalue3", this.seen),
        this.$router
          .push({
            path: "/guanwugongkai/guanwugongkai2/:id",
            query: { orderId: "文博动态", zixun: "wenbodongtai" },
          })
          .catch((err) => {
            err;
          });
    },
    // nav5(i) {
    //   (this.choose = i),
    //     (this.seen = false),
    //     this.$emit("childByvalue3", this.seen),
    //     this.$router
    //       .push({
    //         path: "/guanwugongkai/dashiji/:id",
    //         query: { orderId: "大事记", zixun: true },
    //       })
    //       .catch((err) => {
    //         err;
    //       });
    // },
    onMouseOver1(i) {
      this.choose = i;
    },
    onMouseout1(i) {
      this.choose = "";
    },
  },
  components: {},
  mounted() {},
};
</script>
<style scoped>
.second_nav {
  width: 100%;
  height: 50px;
  background: rgb(78, 104, 161);
  border-top: 5px solid rgb(0, 54, 103);
  box-sizing: border-box;
  padding: 0px 584px 0px;
  position: absolute;
  top: 100px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 10000;
}
.second_nav ul {
  display: flex;
  /* width: 100%; */
  height: 30px;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: -98px;
  right: 0px;
  bottom: 0px;
  margin: auto;
}
.second_nav ul li {
  margin: 0 7px 0px;
}
.second_nav ul li:first-child img {
  display: none;
}
.second_nav ul li p {
  font-size: 16px;
  width: 75px;
}
.second_nav ul li img {
  margin-right: 15px;
}
.white {
  /* font-size:24px; */
  font-size: 14px;
  color: white;
}
.second_nav ul li a {
  color: white;
  margin-right: 60px;
  width: 150px;
  font-size: 18px;
  color: white;
  display: flex;
}
.second_nav ul li {
  display: flex;
  justify-content: center;
  align-items: center;
}
li {
  list-style: none;
  text-align: center;
  cursor: pointer;
}
ul,
p {
  margin: 0px;
  padding: 0px;
}
.p_color {
  color: rgb(0, 54, 103);
}

a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/consult.vue